<template>
	<div
		v-if="fileData"
		:class="{ 'folder-structure': true, 'root-folder': rootFolder }"
	>
		<div class="folder-header">
			<div
				class="folder-assoc"
				v-if="!rootFolder"
			>
				<div class="horizontal"></div>
			</div>
			<i class="fas fa-folder"></i>
			{{ folderName }}
		</div>
		<div class="folder-content">
			<div
				v-for="(folder, index) in Object.keys(fileData?.folders)"
				:key="index"
			>
				<DisplayFolderStructure
					:fileData="fileData?.folders[folder]"
					:folderName="folder"
				/>
			</div>
			<div class="files-row">
				<div
					v-for="(file, index) in fileData?.files"
					:key="index"
					class="file-header"
				>
					<div
						:class="{
							'folder-assoc': true,
							'last-item': index == fileData?.files.length - 1,
						}"
					>
						<div class="vertical"></div>
						<div class="horizontal"></div>
					</div>
					<i class="far fa-file"></i>
					{{ file.name }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'DisplayFolderStructure',
		props: ['fileData', 'folderName', 'rootFolder'],
		data() {
			return {};
		},
		computed: {},
		created() {},
		mounted() {},
		methods: {},
		components: {},
	};
</script>
<style>
	.folder-structure {
		border-left: 1px solid var(--black-70percent);
		background: var(--customerscreen-nav-color);
	}
	.folder-structure.root-folder {
		border: none !important;
	}

	.folder-structure i {
		margin: 0 10px 0 5px;
	}

	.folder-structure.root-folder > .folder-header {
		padding-left: 15px;
	}

	.folder-structure .folder-content {
		padding-left: 20px;
	}

	.folder-structure .folder-header {
		background: var(--fimenupaymentsheetpage-color-4);
		height: 30px;
		margin-top: 1px;
	}

	.folder-structure .file-header {
		height: 25px;
	}
	.folder-structure .folder-header i {
		color: var(--pill-warning-color);
		stroke: 1px red;
	}

	.folder-structure .folder-header,
	.folder-structure .file-header {
		display: flex;
		align-items: center;
	}

	.folder-structure .folder-assoc {
		display: flex;
		align-items: center;
		padding-right: 5px;
		height: 100%;
	}

	.folder-structure .folder-assoc .vertical {
		background: var(--black-70percent);
		width: 1px;
		height: 100%;
	}
	.folder-structure .folder-assoc.last-item .vertical {
		height: calc(50%);
		align-self: flex-start;
	}

	.folder-structure .folder-assoc .horizontal {
		height: 1px;
		background: var(--black-70percent);
		width: 10px;
	}
</style>
